import dayjs from 'dayjs';

import { APP_LOCAL_DATETIME_FORMAT } from 'app/config/constants';
import moment from 'moment';
import { Storage } from 'react-jhipster';

export const convertDateTimeFromServer = date => (date ? dayjs(date).format(APP_LOCAL_DATETIME_FORMAT) : null);

export const convertDateTimeToServer = date => (date ? dayjs(date).toDate() : null);

export const displayDefaultDateTime = () => dayjs().startOf('day').format(APP_LOCAL_DATETIME_FORMAT);

export const formatDate = (date: Date) => {
  if (date) {
    return dayjs(date).format('YYYY/MM/DD');
  }
};

export const FRIDAY_PRAYER_START_TIME = '13:15:00';
export const FRIDAY_PRAYER_END_TIME = '13:45:00';

export const isDuringFridayPrayer = () => {
  const currentTime = moment().tz('Asia/Kuala_Lumpur').format('HH:mm:ss');
  return currentTime >= FRIDAY_PRAYER_START_TIME && currentTime <= FRIDAY_PRAYER_END_TIME && isFriday();
};

export const isFriday = () => {
  const currDate = new Date();
  return currDate.getDay() === 5;
};

export const getLocalPrayerTimeStart = () => {
  return moment.tz(FRIDAY_PRAYER_START_TIME, 'HH:mm:ss', 'Asia/Kuala_Lumpur').local().format('hh:mm A');
};

export const getLocalPrayerTimeEnd = () => {
  return moment.tz(FRIDAY_PRAYER_END_TIME, 'HH:mm:ss', 'Asia/Kuala_Lumpur').local().format('hh:mm A');
};

// Function to format date to DD/MM/YYYY with Western numerals
export const formatDateEng = date => {
  if (!date) return '.......';
  try {
    const dateObj = new Date(date);
    if (isNaN(dateObj.getTime())) return '.......';
    return dateObj.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  } catch {
    return '.......';
  }
};

export function formatDateToLocal(timeDateString) {
  if (!timeDateString) return '';
  try {
    const dateObj = moment.tz(timeDateString, 'HH:mm:ss.SSS DD MMM YYYY', 'Asia/Kuala_Lumpur');
    const localDate = dateObj.local().format(Storage.session.get('locale') === 'en' ? 'DD/MM/yyyy' : 'yyyy/MM/DD');
    return localDate;
  } catch (error) {
    console.error('Error parsing date:', error);
    return timeDateString;
  }
}

export function formatTimeToLocal(timeDateString) {
  if (!timeDateString) return '';
  try {
    const dateObj = moment.tz(timeDateString, 'HH:mm:ss.SSS DD MMM YYYY', 'Asia/Kuala_Lumpur');
    const localTime = dateObj.local().format('HH:mm:ss');
    return localTime;
  } catch (error) {
    console.error('Error parsing time:', error);
    return timeDateString;
  }
}

export const formatDateWithLTR = date => {
  const formattedDate = moment(date).locale('en').format('DD MMMM YYYY');
  return '\u200E' + formattedDate + '\u200E';
};
